import Vue from 'vue'
import { fetchOptionBriefs, fetchOptionDetails } from 'apis/option'
import getLocalFixedQuoteDetail from './getLocalFixedQuoteDetail'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
export default class Option {
  constructor(symbol, expiry, strike, right) {
    this.symbol = symbol
    this.expiry = expiry
    this.strike = strike
    this.right = right

    this.params = {
      expiry: this.expiry,
      strike: this.strike,
      right: (this.right || '').toLowerCase()
    }
  }

  static async getAllOptionBriefs(items) {
    const { data: respData } = await fetchOptionBriefs({ items })
    return (respData.items || []).map(detail => {
      detail.secType = SEC_TYPE.OPT
      detail.market = MARKET_TYPE.US
      return getLocalFixedQuoteDetail(detail)
    })
  }

  static async getAllOptionDetails(items) {
    const { data: respData } = await fetchOptionDetails({ items })
    return (respData.items || []).map(detail => {
      detail.secType = SEC_TYPE.OPT
      detail.market = MARKET_TYPE.US
      return getLocalFixedQuoteDetail(detail)
    })
  }

  getBrief(options) {
    return Vue.http
      .get(`~option/option/brief/${this.symbol}`, {
        params: this.params,
        ...options
      })
      .then(({ data: detail }) => {
        return getLocalFixedQuoteDetail(detail)
      })
  }

  getDetail(options) {
    return Vue.http
      .get(`~option/option/quote/${this.symbol}`, {
        params: this.params,
        ...options
      })
      .then(({ data: detail }) => {
        detail.secType = SEC_TYPE.OPT
        detail.market = MARKET_TYPE.US
        return getLocalFixedQuoteDetail(detail)
      })
  }

  getTimeTrendData(beginTime = -1, options) {
    const params = Object.assign({}, this.params, {
      beginTime,
      symbol: this.symbol
    })
    return Vue.http.get(`~option/option/minute/${this.symbol}`, {
      params,
      ...options
    })
  }

  klinePromise(period = 'day', beginTime = -1, endTime = -1, options) {
    const params = Object.assign({}, this.params, {
      beginTime,
      endTime
    })
    return Vue.http.get(`~option/option/kline/${this.symbol}`, {
      params,
      ...options
    })
  }
}
